import React, { useState } from 'react';
import './Archive.scss';
import { Form } from 'antd';
import ShipmentManagementSubHeader from '../ShipmentManagement/ShipmentManagementSubHeader/ShipmentManagementSubHeader';
import ArchiveSearchBar from './ArchiveSearchBar/ArchiveSearchBar';
import ArchiveHeader from './ArchiveHeader/ArchiveHeader';
import ArchiveList from './ArchiveList/ArchiveList';
import { FilterCounterProvider } from '../Filters/FilterCounterContext';

const Archive = (props) => {
  const [bookingList, setBookingList] = useState([]);
  const [filterList, setFilterList] = useState({});
  const [form] = Form.useForm();

  function addToBookingList(booking) {
    setBookingList([...bookingList, booking]);
  }

  function removeFromBookingList(booking) {
    setBookingList(bookingList.filter(bookingEntry => bookingEntry !== booking));
  }

  function clearBookingList() {
    setBookingList([]);
  }

  function filterBookingNumber(e) {
    addToBookingList(e.target.value);
    form.resetFields();
  }

  return (
    <div className="Archive">
      <ArchiveHeader />
      <FilterCounterProvider>
        <ArchiveSearchBar form={form} filterBookingNumber={filterBookingNumber} filterList={filterList}
                          setFilterList={setFilterList} />
      </FilterCounterProvider>
      <ShipmentManagementSubHeader bookingList={bookingList} removeFromBookingList={removeFromBookingList}
                                   clearBookingList={clearBookingList} />

      <ArchiveList bookingList={bookingList} filterList={filterList} />
    </div>
  );
};

export default Archive;
